import { useEffect, useState } from 'react';
import { getPageAdmin, updatePageAdmin } from '../../services/page-admin.service';
import { PageAdminDto } from '../../services/dtos/page-admin.dto';
import { Skeleton } from '@mui/material';
import { showAxiosMessageError } from '../../utils/error-message.util';
import { useSnackbars } from '../../hooks/snackbar.hook';
import PageAdminForm from '../../components/forms/admin/pages/page-admin.form';
import { useNavigate } from 'react-router-dom';

/**
 * Page admin update
 * @constructor
 */
export default function PageAdminUpdatePage(props: Readonly<{ pageName: string }>) {
    //Disable ou non le bouton de la validation
    const [page, setPage] = useState<PageAdminDto>();
    //Disable ou non le bouton de la validation
    const [loading, setLoading] = useState(false);
    //SnackBar
    const showMessage = useSnackbars();
    //Navigate
    const navigate = useNavigate();

    useEffect(() => {
        let isMounted = true;
        setPage(undefined);
        //Récupération de la page
        getPageAdmin(props.pageName)
            .then(result => {
                isMounted && setPage(result);
            })
            .catch(error => {
                //Affichage du message d'erreur si la requete ne récupère rien
                showAxiosMessageError(error, showMessage);
            });

        return () => {
            isMounted = false;
        };
    }, [props.pageName, showMessage]);

    // Comportement au submit du formulaire Login
    const handlerSubmit = (form: PageAdminDto): void => {
        setLoading(true);
        updatePageAdmin(form)
            .then(() => {
                showMessage.successAlert('Enregistrement des données réussi');
                navigate('/');
            })
            .catch(error => {
                //Affichage du message d'erreur si la requete ne récupère rien
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    //Conditionnement de la vue
    return page ? (
        <PageAdminForm page={page} handlerSubmit={handlerSubmit} loading={loading} />
    ) : (
        <Skeleton height={300} />
    );
}
